<script lang="ts" module>
    export const route = "/ms365-admin-consent";
    export const sessionRequired = false;
</script>

<script lang="ts">
    import { Button } from "../lib/components/ui/button";
    import { Card, CardContent } from "../lib/components/ui/card";
    import { Input } from "../lib/components/ui/input";
    import { Label } from "../lib/components/ui/label";
    import { m } from "../lib/messages.svelte.js";
    import icon from "../assets/icon-192x192.png";

    let tenantId = $state("");

    function handleSubmit() {
        if (!tenantId.trim()) return;

        const clientId = import.meta.env["VITE_MICROSOFT_CLIENT_ID"];
        const scope = "https://graph.microsoft.com/.default";
        const redirectUri = "https://assistant.turian.ai/ms365-admin-consent-callback";

        const consentUrl = `https://login.microsoftonline.com/${tenantId}/v2.0/adminconsent?client_id=${clientId}&scope=${encodeURIComponent(scope)}&redirect_uri=${encodeURIComponent(redirectUri)}`;

        window.location.href = consentUrl;
    }
</script>

<div class="bg-background flex min-h-screen items-center justify-center p-4">
    <Card class="w-full max-w-md">
        <CardContent class="pt-12">
            <enhanced:img src={icon} alt="Turian Logo" class="mx-auto mb-8 h-20 w-20" />

            <h1 class="mb-2 text-center text-2xl font-semibold">{m["ms365AdminConsent.startTitle"]()}</h1>
            <p class="text-muted-foreground mb-8 text-center">
                {m["ms365AdminConsent.startDescription"]()}
            </p>

            <form onsubmit={handleSubmit} class="space-y-6">
                <div class="space-y-2">
                    <Label for="tenant-id">{m["ms365AdminConsent.tenantIdLabel"]()}</Label>
                    <Input
                        id="tenant-id"
                        type="text"
                        placeholder={m["ms365AdminConsent.tenantIdPlaceholder"]()}
                        bind:value={tenantId}
                        class="font-mono"
                    />
                </div>

                <Button type="submit" class="w-full" disabled={!tenantId.trim()}>
                    {m["ms365AdminConsent.startButton"]()}
                </Button>
            </form>
        </CardContent>
    </Card>
</div>
